module.exports = __webpack_public_path__ + "img/success-with-dg-woodpacking-bosspack-en.6199b7d0.svg";